export default __webpack_public_path__ + "static/media/juggyswap-background.4982272e.jpg";